import React, { Component } from 'react';
import { connect } from 'react-redux'
import { logOut } from '../Actions/Login'
import { Link } from 'react-router-dom'

import config from  '../config/config'

export default function Navigation() {
  return (
    <div className="navigation">

      <div className="container">

      <div className="wrap">

      <div className="logo">
        <Link to='/'>PAUL JOSEPH COX</Link>

      </div>

      <nav className="main">
        <Link to='/resume'>Resume</Link>
        <Link to='/portfolio'>Portfolio</Link>
        <Link to='/contact'>Contact</Link>
      </nav>

      </div>

      </div>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Navigation.js